import { View, Text, type ViewStyle, type StyleProp } from 'react-native';

import styles from './styles';
import Counter from './Counter';

interface NumberOfPeopleFilterProps {
  minimumMen: number;
  minimumWomen: number;
  minimumNonBinary: number;
  style?: StyleProp<ViewStyle>;
  onChangeMinimumMen: (value: number) => void;
  onChangeMinimumWomen: (value: number) => void;
  onChangeMinimumNonBinary: (value: number) => void;
}

/** Play with friends filter. Currently only visible on Sports/Daily */
const NumberOfPeopleFilter = ({
  style,
  minimumMen,
  minimumWomen,
  minimumNonBinary,
  onChangeMinimumMen,
  onChangeMinimumWomen,
  onChangeMinimumNonBinary,
}: NumberOfPeopleFilterProps) => (
  <View style={style}>
    <View style={styles.row}>
      <Text style={styles.label}>Men</Text>
      <Counter value={minimumMen} onChange={onChangeMinimumMen} />
    </View>
    <View style={styles.row}>
      <Text style={styles.label}>Women</Text>
      <Counter value={minimumWomen} onChange={onChangeMinimumWomen} />
    </View>
    <View style={styles.row}>
      <Text style={styles.label}>Non-Binary</Text>
      <Counter value={minimumNonBinary} onChange={onChangeMinimumNonBinary} />
    </View>
  </View>
);

export default NumberOfPeopleFilter;
